import Client from '@gocanvas/client'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  topLevelSheetEntriesSelector,
  sheetsSelector,
} from 'apps/builder/store/selectors'
import { dataSourceContextParamsSelector } from 'apps/formsCreationKit/store/selectors/entities'
import {
  activeModeSelector,
  tableWarningDisplayedSelector,
} from 'apps/studio/store/selectors/studioSettings'
import { studioSettingsActions } from 'apps/studio/store/reducers/settings/studioSettings'
const { setTableWarningDisplayed } = studioSettingsActions
import { appSettingsActions } from 'apps/studio/store/reducers/settings/appSettings'
const { selectSheet, updateFlashMessage } = appSettingsActions
import { actions, lib } from '@gocanvas/client'
const { resetClient, initializeClientEntries } = actions
const {
  tempStorageHooks: { clearTempStorage },
  isAnyLoop,
} = lib

export const TestClient = () => {
  const dispatch = useDispatch()
  const activeMode = useSelector(activeModeSelector)
  const tableWarningDisplayed = useSelector(tableWarningDisplayedSelector)
  const [entriesInitialized, setEntriesInitialized] = useState(false)
  const sheets = useSelector(sheetsSelector)
  const entries = useSelector(topLevelSheetEntriesSelector)
  const dataSourceContextParams = useSelector(dataSourceContextParamsSelector)

  const setSheetHandler = id => dispatch(selectSheet({ sheet_id: id }))

  const submitHandler = () => {
    setEntriesInitialized(false)
    dispatch(resetClient({
      entries,
      dataSourceContextParams,
      validate: false
    }))
    clearTempStorage()
    setTimeout(setEntriesInitialized, 2, true)
  }

  useEffect(() => {
    if (!tableWarningDisplayed && sheets.some(sheet => isAnyLoop(sheet))) {
      dispatch(
        updateFlashMessage({
          message:
            'This form contains tables. The PDF will only show the number of visible rows in each table. Users can enter data beyond the visible rows, and it will be saved in the submission data.',
          type: 'warning',
        })
      )
      dispatch(setTableWarningDisplayed({ tableWarningDisplayed: true }))
    }
  }, [])

  useEffect(() => {
    clearTempStorage()
    dispatch(
      initializeClientEntries({
        entries,
        dataSourceContextParams,
        validate: true
      })
    )
    setEntriesInitialized(true)
  }, [entries, activeMode, dataSourceContextParams])

  return (
    <div className="test-client--container">
      <div className="app--preview--container test-client">
        <div className="client--container app-preview preview--active ">
          {entriesInitialized && (
            <Client
              resetOnSubmit
              onSubmit={submitHandler}
              onSetSheet={setSheetHandler}
            />
          )}
        </div>
      </div>
    </div>
  )
}
